export default "__VITE_ASSET__DYFwTgow__"